import React, { FC } from "react";
import "../assets/styles/styles.scss";
import FooterBackground from "../assets/images/background_footer.svg";
import FooterCompanyLogo from "../assets/images/footer_logo.svg";

interface UrlInfo {
  name: string;
  url: string;
}

interface SiteGroup {
  grpName: string;
  sites: UrlInfo[];
}

const Footer: FC = () => {
  const footerMenus: UrlInfo[] = [
    { name: 'NCDC 소개', url: '' },
    { name: '이용약관', url: '' },
    { name: '개인정보처리방침', url: '' },
  ];
  const address = "경기도 고양시 일산동구 일산로 323(마두1동 809번지) 우편번호 10408 국가암데이터센터, 국립암센터 암빅데이터센터"
  const phone = "대표전화 1588-8110";
  const copyright = "Copyright National Cancer Center. All Rights Reserved.";

  const siteGroup: SiteGroup[] = [
    { grpName: '관련사이트', 
      sites: [
        { name: '보건복지부', url: 'http://www.mohw.go.kr' },
        { name: '국립암센터', url: 'https://www.ncc.re.kr' },
        { name: '결합전문기관', url: 'https://datalink.mohw.go.kr' },
        { name: '공공데이터포털', url: 'https://www.data.go.kr' },
        { name: '가명정보결합종합지원시스템', url: 'https://link.privacy.go.kr' },
      ] 
    },
    { grpName: '내부 관련사이트', 
      sites: [ 
        { name: '데이터 결합포털', url: '' },
        { name: 'CORE 포털', url: '' },
        { name: 'CORE-A 포털', url: '' },
        { name: 'CONNECT 포털', url: 'https://bigdata-cancer.kr' },
      ]
    }
  ];

  return (
    <div className={'footer-wrapper wrapper'}
      style={{ backgroundImage: `url(${FooterBackground})`}}>
      <div className={'footer-content content'}>

        <div className={'footer-info'}>
          <div className={'footer-menu-wrapper'}>
            { footerMenus.map( (menu: UrlInfo, idx: number) => {
              return (
                <div key={idx} className={'footer-menu-content'}>
                  {menu.name}
                </div>
              );
            })}
          </div>
          <span style={{marginBottom: '5px'}}>{address}</span>
          <span style={{marginTop: '5px'}}>{phone}</span>
          <span>{copyright}</span>
          <img src={FooterCompanyLogo} alt=""/>
        </div>

        <div className={'footer-site-wrapper'}>
          { siteGroup.map( (group: SiteGroup, idx: number) => {
            return (
              <div key={idx} className={'footer-site-button flex-center'}>
                {group.grpName}
                <div className={'footer-site-group'}>
                  { group.sites.map( (site: UrlInfo, idx: number) => {
                    return (
                        <a key={idx} href={site.url} target={'_blank'}>
                          <div className={'footer-site'}>{site.name}</div>
                        </a>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  )
}

export default Footer;
